import React from 'react';

const LastUpdatedIcon = () => {
  return (
    (<svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="LastUpdatedIcon">
      <path
        d="M8.2685 8.7835C7.36122 9.56967 6.20051 10.0017 5 10C2.2385 10 0 7.7615 0 5C0 2.2385 2.2385 0 5 0C7.7615 0 10 2.2385 10 5C10 6.068 9.665 7.058 9.095 7.87L7.5 5H9C8.99993 4.0781 8.68141 3.18453 8.09834 2.47045C7.51527 1.75636 6.70343 1.2656 5.80017 1.08118C4.8969 0.896762 3.95767 1.03001 3.14134 1.45838C2.32501 1.88676 1.68171 2.58396 1.32026 3.43204C0.958812 4.28013 0.901403 5.22703 1.15775 6.11257C1.41409 6.99811 1.96845 7.76792 2.72704 8.29178C3.48564 8.81564 4.4019 9.06139 5.32082 8.98744C6.23975 8.9135 7.10493 8.52442 7.77 7.886L8.2685 8.7835Z"
        fill="white"
        fillOpacity="0.5"
      />
    </svg>)
  );
};

export default LastUpdatedIcon;
